export enum ProductType {
  Announcment = 1,
  CvDatabaseAccess = 2,
  Announcement_Logo = 3,
  Announcement_Frame = 4,
  Announcement_Bauble = 5,
  Announcement_Decoration = 6,
  Announcement_FacebookShare = 7,
  Announcement_Anonymous = 8,
  SliderBanner = 9,
  Announcement_LinkedInShare = 10,
  Announcement_Renewal = 11,
  EventCvDatabaseAccess = 12,
  Announcement_Vk_share = 13,
  CvBox = 14,
  Announcement_InstagramShare = 15,
  Announcement_Matching = 16,
  Announcement_InstantRenewal = 17,
  CustomerBranding = 18,
}
